import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { Dayjs } from "dayjs";

class UpdateSelectedBookReturnJourneyDateAction extends BaseAction<void, [Dayjs | null, Dayjs | null]> {

    override async run(): Promise<void> {
        updateRecoilState("selectedBookReturnJourneyDateAtom", this.params);
    }
}

export const updateSelectedBookReturnJourneyDateAction = new UpdateSelectedBookReturnJourneyDateAction()